var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import { datadogRum } from "@datadog/browser-rum";
import { getCurrentEnv } from "./WhichEnv";
/**
 * @param config make sure you provide, applicationId, clientToken and service
 * @returns script version
 */
export var initLogging = function (config) {
    var _a;
    try {
        if (getCurrentEnv() !== "prod" && getCurrentEnv() !== "local") {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires
            var pkg = require("../../package.json");
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            console.log("Claude logging is enabled! (".concat((_a = pkg.version) !== null && _a !== void 0 ? _a : "Unknown version", " - \n                ").concat(getCurrentEnv(), ")"));
            datadogRum.init(__assign(__assign({ site: "datadoghq.eu" }, config), { 
                // applicationId: "x",
                // clientToken: "x",
                // service: "x",
                env: getCurrentEnv(), 
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                version: pkg.version }));
            datadogRum.startSessionReplayRecording();
        }
        else {
            console.warn("Claude logging is not enabled! We don't support this stage: ", getCurrentEnv());
        }
    }
    catch (e) {
        console.error("Claude logging is not enabled! Something went wrong: ", e);
    }
};
